import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Households from "./pages/Households";
import HouseholdForm from "./pages/HouseholdForm";
import HouseholdDetail from "./pages/HouseholdDetail";
import Awareness from "./pages/Awareness";
import AwarenessForm from "./pages/AwarenessForm";
import Villages from "./pages/Villages";
import AwarenessDetail from "./pages/AwarenessDetail";
import Students from "./pages/Students";
import ForgotPassword from "./pages/ForgotPassword";
import Faculty from "./pages/Faculty";
import Account from "./pages/Account";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
          <Route path="/account" element={<Shell><Account /></Shell>} />
          <Route path="/households" element={<Shell><Households /></Shell>} />
          <Route path="/households/new" element={<Shell><HouseholdForm /></Shell>} />
          <Route path="/households/:id/edit" element={<ProtectedRoute role="manager"><Layout><HouseholdForm /></Layout></ProtectedRoute>} />
          <Route path="/households/:id" element={<Shell><HouseholdDetail /></Shell>} />
          <Route path="/awareness" element={<Shell><Awareness /></Shell>} />
          <Route path="/awareness/new" element={<Shell><AwarenessForm /></Shell>} />
          <Route path="/awareness/:id/edit" element={<ProtectedRoute role="manager"><Layout><AwarenessForm /></Layout></ProtectedRoute>} />
          <Route path="/awareness/:id" element={<Shell><AwarenessDetail /></Shell>} />
          <Route path="/villages" element={<Shell><Villages /></Shell>} />
          <Route path="/students" element={<ProtectedRoute role={["faculty", "manager"]}><Layout><Students /></Layout></ProtectedRoute>} />
          <Route path="/faculty" element={<ProtectedRoute role="manager"><Layout><Faculty /></Layout></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
